import { ImageSourcePropType } from 'react-native'

import { useApiAction } from '../../api/useApiAction'
import { UserDetailsProps } from '../../types'
import { Note, state } from '../../utils/types'
import { StatusScreenWrapper } from '../common/statusScreenWrapper'
import ApplicationStatus from './statusContent'

interface Props {
  state: state
  props: {
    status: {
      title?: string
      subTitle?: string
      image?: ImageSourcePropType
    }
    showC1Id?: boolean
    note?: Note
    secondaryButton?: any
    buttons?: any[]
  }
  userDetails: UserDetailsProps
}

export const StatusScreen: React.FC<Props> = (_props) => {
  const { state, props, userDetails } = _props

  const { mutate, data, isLoading } = useApiAction()
  const expiryTimeEpochInMillis = data?.metadata?.kycExpiryTime
  const errorsList = data?.layout?.errorsList

  const updateProps = {
    ...props,
    ...data?.metadata,
    ...(errorsList && { errorsList }),
    ...(data?.layout &&
      !!Object.keys(data?.layout)?.length && {
        status: {
          title:
            props?.status?.statusTitle ??
            data?.layout?.title ??
            props?.status?.title,
          subTitle:
            props?.status?.description ??
            data?.layout?.description ??
            data?.layout?.subTitle ??
            props?.status?.subTitle,
          image: data?.layout?.image ?? props?.status?.image,
          showC1Id: props?.showC1Id,
          c1Id: data?.metadata?.c1Id,
        },
        ...(data?.layout?.buttons && {
          buttons: data?.layout?.buttons,
        }),
        ...(data?.layout?.note && {
          note: data?.layout?.note,
        }),
        ...(data?.layout?.secondaryButton && {
          secondaryButton: data?.layout?.secondaryButton,
        }),
      }),
  }

  return (
    <StatusScreenWrapper
      Content={
        <ApplicationStatus
          userDetails={userDetails}
          props={updateProps}
          data={data}
        />
      }
      state={state}
      note={updateProps?.note}
      buttons={updateProps?.buttons}
      expiryTimeEpochInMillis={expiryTimeEpochInMillis}
      mutate={mutate}
      isLoading={isLoading}
    />
  )
}
